import Immutable from "seamless-immutable";
import * as actionTypes from "./actionTypes";

const initialState = Immutable({
  byId: {},
  params: {},
  error: {},
  actionsloading: false,
});

export function placeReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.FETCH_PLACES:
    case actionTypes.SAVE_PLACE:
    case actionTypes.UPDATE_PLACE:
      return {
        ...state,
        byId: {},
        actionsloading: true,
      };
    case actionTypes.DELETE_PLACE:
      return {
        ...state,
        actionsloading: true,
      };
    case actionTypes.SAVE_PLACE_SUCCESS:
    case actionTypes.UPDATE_PLACE_SUCCESS:
      return {
        ...state,
        byId: {
          ...state.byId,
          [action.payload.placeUid]: action.payload,
        },
        actionsloading: false,
      };
    case actionTypes.FETCH_PLACE_SUCCESS:
    case actionTypes.FETCH_PLACES_SUCCESS:
      return {
        ...state,
        byId: action.payload.byId || {},
        params: action.payload.params || {},
        places: action.payload.places || {},
        placesDropList: action.payload.placesDropList || {},
        actionsloading: false,
      };
    case actionTypes.DELETE_PLACE_SUCCESS:
      Object.keys(state.byId).forEach(function (key, index) {
        if (state.byId[key].placeUid === action.payload.id) {
          delete state.byId[key];
        }
      });
      return {
        ...state,
        byId: state.byId,
        actionsloading: false,
      };
    default:
      return state;
  }
}
